import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'form-root-wrapper',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: ['.form-root-wrapper { display:flex;}'],
  template: ` <ng-container #fieldComponent></ng-container> `,
})
export class FormRootWrapperType extends FieldWrapper {
  @HostBinding('class')
  readonly cssClass = 'form-root-wrapper';
}
